import React from 'react';
import WHStep4 from './WHStep4';

export default function WHStep4Container({ whRegionData, formikProp }) {
  return <WHStep4 formikProp={formikProp} whRegionData={whRegionData} />;
}
